import { createStyles, makeStyles } from '@material-ui/core/styles';

import { colors } from '../../styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    paper: {
      alignItems: 'center',
      boxShadow:
        '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'row',
      height: '100%',
      padding: '5px',
    },
    large: {
      width: theme.spacing(12),
      height: theme.spacing(12),
    },
    company: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginTop: theme.spacing(-3),
      marginLeft: theme.spacing(8),
    },
    username: {
      fontSize: '1.4em',
      fontWeight: 'bold',
      margin: '10px 0 0 0',
      textAlign: 'center',
    },
    name: {
      fontSize: '1.2em',
      margin: 0,
      textAlign: 'center',
    },
    categories: {
      fontFamily: 'Montserrat',
      fontSize: '0.8em',
      fontWeight: 500,
      margin: '10px 0 5px',
      textTransform: 'uppercase',
      textAlign: 'left',
    },
    tz: {
      fontSize: '0.8em',
      fontWeight: 'bold',
      margin: '0 0 2vh',
    },
    info: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      width: '70%',
    },
    metrics: {
      alignItems: 'flex-start',
      borderLeft: `0.5px solid ${colors.greyBg}`,
      display: 'flex',
      flexDirection: 'column',
      margin: '10px 0',
      padding: '0 25px',
      width: '30%',
    },
    metric: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    image: {
      filter: 'grayscale(100%)',
      width: '20%',
    },
    metricNumber: {
      fontSize: '1.8em',
      fontWeight: 'bold',
      margin: 0,
      textTransform: 'uppercase',
    },
    counterView: {
      borderRadius: '2px',
      display: 'block',
      height: '100%',
      width: '70%',
    },
    paperMoodColor: {
      display: 'flex',
      alignItems: 'right',
      height: '3vh',
      width: '80px',
    },
    typographyCountMood: {
      textAlign: 'center',
      alignItems: 'right',
      alignSelf: 'center',
      width: '100%',
      fontWeight: 'bold',
      color: 'white',
    },
    numberBox: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    metricChange: {
      fontSize: '0.8em',
      margin: '0 3px',
      textTransform: 'uppercase',
    },
  })
);
